module.exports = __webpack_public_path__ + "35fcaa304ae379fc76984fbe02d74d43.png";